export default __webpack_public_path__ + "static/media/bg1.54f92f70.png";